import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { DatabaseModel, Group, GroupMember } from '../../models';
import { AutoSub, AutoSubOnDestroy, GroupService } from '../../providers';
import { MotesLoginService } from '../../motes-login/motes-login.service';

/**
 * Display a list of group members and the group join ID
 */
@AutoSubOnDestroy()
@Component({
    selector: 'group-overview',
    templateUrl: './group-overview.component.html',
    styleUrls: ['./group-overview.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class GroupOverviewComponent implements OnInit {

    public group: Group = null;
    public members: GroupMember[];
    public loading: boolean = false;

    constructor(private groupService: GroupService, public loginService: MotesLoginService) { }

    ngOnInit(): void {
        AutoSub(this).reg['group'] = this.groupService.watchCurrentGroup().subscribe((group) => {
            this.group = group;
            // Convert group members from mapped type to array
            if(group) this.members = DatabaseModel.mapToArray(group.members);
        });
    }

    /**
     * Remove a group member
     * @param userKey key for the group member to remove
     */
    public removeMember(userKey: string) {
        this.groupService.removeMember(this.group.key, userKey);
    }

    /**
     * Allows the current user to leave it's current group.
     */
    public async leaveGroup(): Promise<void> {
        this.loading = true;
        await this.groupService.leaveGroup();
        this.loading = false;
    }

    /**
     * Copy the group join ID to the clipboard
     */
    public copyGroupId() {
        navigator.clipboard.writeText(this.group.joinId.toString());
    }
}
